// extracted by mini-css-extract-plugin
export default {"landing":"Landing_landing__9+qQl","catalog":"Landing_catalog__0e3Mg"};